"use client";

import { logout } from "@/actions/logout";
import { signOut } from "next-auth/react";

import { Icons } from "@/config/icons";
import { useCompany } from "@/hooks/use-store-modal";
import { Button } from "@/components/ui/button";

export const LogoutButton = () => {
  const currentCompany = useCompany();
  const onClick = () => {
    signOut();
    currentCompany.selectStoreId("");
    currentCompany.selectStore("");
  };

  return (
    <Button variant={"outline"} onClick={onClick} className="cursor-pointer">
      <Icons.exitIcon className="h-4 w-4" />
    </Button>
  );
};
